var _path, _g, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _g3, _path8, _g4, _path9, _g5, _path10, _g6, _path11, _g7, _path12, _g8, _path13, _g9, _path14, _g10, _path15, _g11, _rect, _rect2, _rect3, _path16, _path17, _path18, _path19, _path20, _g12, _g13, _path21, _path22, _path23, _g14, _g15, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g16, _path34, _line, _line2, _line3, _line4, _line5, _line6, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _line7, _path35, _path36, _g17, _path37, _line8, _line9, _line10, _line11, _line12, _line13, _rect12, _rect13, _rect14, _line14, _path38, _path39, _g18, _path40, _path41, _path42, _path43, _path44, _g19, _path45, _path46, _g20, _path47, _path48, _g21, _path49, _path50, _g22, _path51, _path52, _path53, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImg5Sect4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 538,
    height: 391,
    viewBox: "0 0 538 391",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.5983 88C82.6182 88 76.9082 93.71 76.9082 100.69V358.527C76.9082 365.507 82.6182 371.217 89.5983 371.217H464.165C471.145 371.217 476.855 365.507 476.855 358.527V100.69C476.855 93.71 471.143 88 464.165 88H89.5983Z",
    fill: "#343A8A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.06,
    filter: "url(#filter0_d_369_1662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.973 373.732H139.589H46.7194L31.8902 378.597C29.7292 379.306 30.2393 382.497 32.5136 382.497H139.588H417.973H524.9C527.191 382.497 527.683 379.272 525.497 378.588L509.965 373.732H417.973Z",
    fill: "#010630"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M416.409 365.327H137.887H31.3936C31.3936 365.327 36.7176 371.218 52.8977 371.218H137.889H416.41H501.401C517.578 371.218 522.904 365.327 522.904 365.327H416.409Z",
    fill: "#010630"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M416.409 365.327H137.887H31.3936C31.3936 365.327 36.7176 371.218 52.8977 371.218H137.889H416.41H501.401C517.578 371.218 522.904 365.327 522.904 365.327H416.409Z",
    fill: "#010630"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M522.902 355.905H31.3936V365.325H522.902V355.905Z",
    fill: "#2B306E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M311.966 357.064H243.019C243.019 359.441 244.945 361.366 247.318 361.366H307.665C310.04 361.368 311.966 359.443 311.966 357.064Z",
    fill: "#010630"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_369_1662",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 103,
    width: 381,
    height: 246
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M467.045 103.022H87.2549V348.025H467.045V103.022Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_369_1662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.766 103.385H85.3164V118.681H472.766V103.385Z",
    fill: "#F2F2F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_369_1662",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 103,
    width: 381,
    height: 246
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M467.045 103.022H87.2549V348.025H467.045V103.022Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_369_1662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.523 119.986H192.392L197.605 106.687H267.308L272.523 119.986Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_369_1662",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 103,
    width: 381,
    height: 246
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M467.045 103.022H87.2549V348.025H467.045V103.022Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_369_1662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.766 118.681H85.3164V138.496H472.766V118.681Z",
    fill: "#B6B7CD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_369_1662",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 103,
    width: 381,
    height: 246
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M467.045 103.022H87.2549V348.025H467.045V103.022Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_369_1662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.778 129.407C448.778 131.538 447.035 133.281 444.904 133.281H126.564C124.433 133.281 122.689 131.538 122.689 129.407V127.769C122.689 125.638 124.433 123.895 126.564 123.895H444.906C447.037 123.895 448.78 125.638 448.78 127.769L448.778 129.407Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_369_1662",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 103,
    width: 381,
    height: 246
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M467.045 103.022H87.2549V348.025H467.045V103.022Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_369_1662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.732 119.986H124.601L129.814 106.687H199.517L204.732 119.986Z",
    fill: "#B6B7CD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_369_1662",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 103,
    width: 381,
    height: 246
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M467.045 103.022H87.2549V348.025H467.045V103.022Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_369_1662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.88 111.207C95.88 112.996 94.4302 114.446 92.6407 114.446C90.8511 114.446 89.4014 112.996 89.4014 111.207C89.4014 109.419 90.8528 107.967 92.6407 107.967C94.4286 107.967 95.88 109.419 95.88 111.207Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_369_1662",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 103,
    width: 381,
    height: 246
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M467.045 103.022H87.2549V348.025H467.045V103.022Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_369_1662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.524 111.207C106.524 112.996 105.075 114.446 103.285 114.446C101.496 114.446 100.046 112.996 100.046 111.207C100.046 109.419 101.496 107.967 103.285 107.967C105.073 107.967 106.524 109.419 106.524 111.207Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_369_1662",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 103,
    width: 381,
    height: 246
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M467.045 103.022H87.2549V348.025H467.045V103.022Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_369_1662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.167 111.207C117.167 112.996 115.716 114.446 113.928 114.446C112.138 114.446 110.688 112.996 110.688 111.207C110.688 109.419 112.138 107.967 113.928 107.967C115.716 107.967 117.167 109.419 117.167 111.207Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_369_1662",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 103,
    width: 381,
    height: 246
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M467.045 103.022H87.2549V348.025H467.045V103.022Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_369_1662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.141 137.083H85.7363V348.315H473.141V137.083Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_369_1662",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 103,
    width: 381,
    height: 246
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M467.045 103.022H87.2549V348.025H467.045V103.022Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_369_1662)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M81.3535 354.45V137.083H166.372V354.45",
    fill: "url(#paint0_linear_369_1662)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 166.372,
    y: 137.083,
    width: 300.633,
    height: 14.0237,
    fill: "#2B306E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.95,
    x: 98.0068,
    y: 160.748,
    width: 56.9713,
    height: 21.912,
    rx: 2,
    fill: "#2B306E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.95,
    x: 98.0068,
    y: 229.113,
    width: 56.9713,
    height: 11.3943,
    rx: 2,
    fill: "#FF00B1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M126.053 167.76H105.018V170.389H126.053V167.76Z",
    fill: "#ECEDFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M147.966 234.372H104.142V236.125H147.966V234.372Z",
    fill: "#ECEDFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M147.089 281.702H103.265V283.455H147.089V281.702Z",
    fill: "#808080",
    fillOpacity: 0.8
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M147.966 258.037H104.142V259.79H147.966V258.037Z",
    fill: "#808080",
    fillOpacity: 0.8
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M147.089 174.771H105.018V175.648H147.089V174.771Z",
    fill: "#ECEDFF"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter1_dd_369_1662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.501 161.661H341.506C339.849 161.661 338.506 163.004 338.506 164.661V228.327C338.506 229.984 339.849 231.327 341.506 231.327H427.501C429.158 231.327 430.501 229.984 430.501 228.327V164.661C430.501 163.004 429.158 161.661 427.501 161.661Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.319 193.299C357.084 196.534 354.518 200.374 352.768 204.6C351.017 208.826 350.116 213.355 350.116 217.93H367.933C367.933 215.695 368.373 213.482 369.229 211.418C370.084 209.354 371.337 207.478 372.917 205.898L360.319 193.299Z",
    fill: "#B6B7CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.58 193.299C406.345 190.064 402.505 187.499 398.279 185.748C394.053 183.998 389.524 183.097 384.949 183.097C380.375 183.097 375.845 183.998 371.619 185.748C367.393 187.499 363.553 190.064 360.319 193.299L372.917 205.898C374.497 204.318 376.373 203.064 378.438 202.209C380.502 201.354 382.715 200.914 384.949 200.914C387.184 200.914 389.396 201.354 391.461 202.209C393.525 203.064 395.401 204.318 396.981 205.898L409.58 193.299Z",
    fill: "#2B306E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.782 217.93C419.782 213.355 418.881 208.826 417.131 204.6C415.38 200.374 412.814 196.534 409.58 193.299L396.981 205.898C398.561 207.478 399.815 209.354 400.67 211.418C401.525 213.482 401.965 215.695 401.965 217.93H419.782Z",
    fill: "#FF00B1"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M385.462 219.16C386.142 218.877 386.463 218.097 386.18 217.417C385.897 216.737 385.116 216.416 384.436 216.699C383.757 216.982 383.435 217.763 383.718 218.443C384.002 219.122 384.782 219.444 385.462 219.16ZM376.248 196.398C376.195 196.27 376.049 196.21 375.922 196.263C375.794 196.316 375.734 196.463 375.787 196.59L376.248 196.398ZM385.18 217.834L376.248 196.398L375.787 196.59L384.718 218.026L385.18 217.834Z",
    fill: "#687079"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M396.56 167.02H347.437V168.806H396.56V167.02Z",
    fill: "#333232"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M376.017 175.058H347.437V175.951H376.017V175.058Z",
    fill: "#333232"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter2_dd_369_1662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.5 243.831H191.455C189.798 243.831 188.455 245.174 188.455 246.831V336.398C188.455 338.055 189.798 339.398 191.455 339.398H427.5C429.157 339.398 430.5 338.055 430.5 336.398V246.831C430.5 245.174 429.157 243.831 427.5 243.831Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M206.239 263.48L203.353 268.48H209.126L206.239 263.48ZM205.739 267.98V323.596H206.739V267.98H205.739Z",
    fill: "#010630"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M408.171 323.817L403.171 320.93V326.704L408.171 323.817ZM206.318 324.317H403.671V323.317H206.318V324.317Z",
    fill: "#010630"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M239.402 263.48V323.596",
    stroke: "#010630",
    strokeMiterlimit: 10,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M272.563 263.48V323.596",
    stroke: "#010630",
    strokeMiterlimit: 10,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M305.726 263.48V323.596",
    stroke: "#010630",
    strokeMiterlimit: 10,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M338.889 263.48V323.596",
    stroke: "#010630",
    strokeMiterlimit: 10,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M372.052 263.48V323.596",
    stroke: "#010630",
    strokeMiterlimit: 10,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M401.64 263.48V323.596",
    stroke: "#010630",
    strokeMiterlimit: 10,
    strokeDasharray: "2 2"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M205.411 305.52L247.517 277.498L271.72 314.282L304.269 268.48L338.111 322.399L370.66 311.19L401.026 321.089",
    stroke: "#010630",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M208.946 304.812C208.946 306.093 207.557 307.131 205.845 307.131C204.134 307.131 202.745 306.093 202.745 304.812C202.745 303.531 204.134 302.493 205.845 302.493C207.557 302.493 208.946 303.531 208.946 304.812Z",
    fill: "#FF00B1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M238.395 285.294C240.107 285.294 241.495 284.256 241.495 282.975C241.495 281.694 240.107 280.656 238.395 280.656C236.683 280.656 235.295 281.694 235.295 282.975C235.295 284.256 236.683 285.294 238.395 285.294Z",
    fill: "#FF00B1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M271.719 316.601C273.432 316.601 274.82 315.563 274.82 314.282C274.82 313.001 273.432 311.962 271.719 311.962C270.007 311.962 268.619 313.001 268.619 314.282C268.619 315.563 270.007 316.601 271.719 316.601Z",
    fill: "#FF00B1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M307.368 268.479C307.368 269.76 305.98 270.799 304.268 270.799C302.556 270.799 301.168 269.76 301.168 268.479C301.168 267.199 302.556 266.16 304.268 266.16C305.98 266.16 307.368 267.199 307.368 268.479Z",
    fill: "#FF00B1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M337.592 323.751C339.305 323.751 340.693 322.713 340.693 321.432C340.693 320.151 339.305 319.113 337.592 319.113C335.88 319.113 334.492 320.151 334.492 321.432C334.492 322.713 335.88 323.751 337.592 323.751Z",
    fill: "#FF00B1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M370.661 313.509C372.373 313.509 373.761 312.47 373.761 311.189C373.761 309.909 372.373 308.87 370.661 308.87C368.949 308.87 367.561 309.909 367.561 311.189C367.561 312.47 368.949 313.509 370.661 313.509Z",
    fill: "#FF00B1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M400.669 323.366C402.381 323.366 403.769 322.327 403.769 321.046C403.769 319.765 402.381 318.727 400.669 318.727C398.956 318.727 397.568 319.765 397.568 321.046C397.568 322.327 398.956 323.366 400.669 323.366Z",
    fill: "#FF00B1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M226.861 258.122H198.28V259.015H226.861V258.122Z",
    fill: "#333232"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M247.404 250.083H198.28V251.87H247.404V250.083Z",
    fill: "#333232"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_369_1662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.524 267.053H32.4746C30.8178 267.053 29.4746 268.396 29.4746 270.053V338.184C29.4746 339.841 30.8178 341.184 32.4746 341.184H176.524C178.181 341.184 179.524 339.841 179.524 338.184V270.053C179.524 268.396 178.181 267.053 176.524 267.053Z",
    fill: "#ECEDFF"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M39.2988 288.488L39.2988 334.039",
    stroke: "#595959",
    strokeWidth: 0.4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 39.2988,
    y1: 326.844,
    x2: 169.699,
    y2: 326.844,
    stroke: "#595959",
    strokeWidth: 0.1,
    strokeDasharray: "0.5 0.5"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 39.2988,
    y1: 298.263,
    x2: 169.699,
    y2: 298.263,
    stroke: "#595959",
    strokeWidth: 0.1,
    strokeDasharray: "0.5 0.5"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 39.2988,
    y1: 305.408,
    x2: 169.699,
    y2: 305.408,
    stroke: "#595959",
    strokeWidth: 0.1,
    strokeDasharray: "0.5 0.5"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 39.2988,
    y1: 312.554,
    x2: 169.699,
    y2: 312.553,
    stroke: "#595959",
    strokeWidth: 0.1,
    strokeDasharray: "0.5 0.5"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 39.2988,
    y1: 291.118,
    x2: 169.699,
    y2: 291.118,
    stroke: "#595959",
    strokeWidth: 0.1,
    strokeDasharray: "0.5 0.5"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 39.2988,
    y1: 319.699,
    x2: 169.699,
    y2: 319.699,
    stroke: "#595959",
    strokeWidth: 0.1,
    strokeDasharray: "0.5 0.5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 54.4824,
    y: 297.42,
    width: 7.14523,
    height: 36.6193,
    fill: "#343A8A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 65.2002,
    y: 304.565,
    width: 7.14523,
    height: 29.4741,
    fill: "#FB91DB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 85.7432,
    y: 319.749,
    width: 7.14523,
    height: 14.2905,
    fill: "#343A8A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 96.4609,
    y: 312.604,
    width: 7.14523,
    height: 21.4357,
    fill: "#FB91DB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 117.003,
    y: 294.74,
    width: 7.14523,
    height: 39.2988,
    fill: "#343A8A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 127.721,
    y: 305.458,
    width: 7.14523,
    height: 28.5809,
    fill: "#FB91DB"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 148.264,
    y: 291.168,
    width: 7.14523,
    height: 42.8714,
    fill: "#343A8A"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 158.981,
    y: 319.749,
    width: 7.14523,
    height: 14.2905,
    fill: "#FB91DB"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 39.2988,
    y1: 333.839,
    x2: 169.699,
    y2: 333.839,
    stroke: "#595959",
    strokeWidth: 0.4
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4223 273.305H39.2988V275.091H88.4223V273.305Z",
    fill: "#333232"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M67.8797 281.343H39.2988V282.236H67.8797V281.343Z",
    fill: "#333232"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_369_1662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M516.815 257.228H415.637C413.98 257.228 412.637 258.571 412.637 260.228V328.36C412.637 330.017 413.98 331.36 415.637 331.36H516.815C518.472 331.36 519.815 330.017 519.815 328.36V260.228C519.815 258.571 518.472 257.228 516.815 257.228Z",
    fill: "#ECEDFF"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M419.654 276.877L419.654 324.215",
    stroke: "#595959",
    strokeWidth: 0.4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 419.654,
    y1: 317.403,
    x2: 512.797,
    y2: 317.403,
    stroke: "#595959",
    strokeWidth: 0.1,
    strokeDasharray: "0.5 0.5"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 419.654,
    y1: 290.353,
    x2: 512.797,
    y2: 290.353,
    stroke: "#595959",
    strokeWidth: 0.1,
    strokeDasharray: "0.5 0.5"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 419.654,
    y1: 297.115,
    x2: 512.797,
    y2: 297.115,
    stroke: "#595959",
    strokeWidth: 0.1,
    strokeDasharray: "0.5 0.5"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 419.654,
    y1: 303.877,
    x2: 512.797,
    y2: 303.877,
    stroke: "#595959",
    strokeWidth: 0.1,
    strokeDasharray: "0.5 0.5"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 419.654,
    y1: 283.59,
    x2: 512.797,
    y2: 283.59,
    stroke: "#595959",
    strokeWidth: 0.1,
    strokeDasharray: "0.5 0.5"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 419.654,
    y1: 310.64,
    x2: 512.797,
    y2: 310.64,
    stroke: "#595959",
    strokeWidth: 0.1,
    strokeDasharray: "0.5 0.5"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 419.782,
    y: 300.546,
    width: 65.2002,
    height: 6.76245,
    fill: "#FF58CC"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 419.782,
    y: 314.071,
    width: 42.8714,
    height: 6.76245,
    fill: "#FFB0E7"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 419.782,
    y: 287.021,
    width: 84.8496,
    height: 6.76245,
    fill: "#FF00B1"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 419.654,
    y1: 324.015,
    x2: 512.797,
    y2: 324.015,
    stroke: "#595959",
    strokeWidth: 0.4
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M484.982 264.374H419.782V266.16H484.982V264.374Z",
    fill: "#333232"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M448.363 270.625H419.782V271.519H448.363V270.625Z",
    fill: "#333232"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_369_1662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M516.572 149.157H429.034C427.377 149.157 426.034 150.5 426.034 152.157V231.899C426.034 233.556 427.377 234.899 429.034 234.899H516.572C518.229 234.899 519.572 233.556 519.572 231.899V152.157C519.572 150.5 518.229 149.157 516.572 149.157Z",
    fill: "#ECEDFF"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M479.623 158.088H432.286V159.874H479.623V158.088Z",
    fill: "#333232"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M497.746 199.433C497.746 196.106 497.091 192.812 495.818 189.739C494.545 186.665 492.679 183.872 490.326 181.52C487.974 179.168 485.181 177.302 482.108 176.028C479.034 174.755 475.74 174.1 472.413 174.1L472.413 199.433H497.746Z",
    fill: "#FF00B1"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M497.746 199.433C497.746 204.443 496.26 209.341 493.477 213.507C490.693 217.673 486.737 220.92 482.108 222.838C477.479 224.755 472.385 225.257 467.471 224.279C462.557 223.302 458.043 220.889 454.5 217.346L472.413 199.433H497.746Z",
    fill: "#010630"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M472.413 174.1C467.403 174.1 462.505 175.586 458.339 178.369C454.173 181.153 450.926 185.109 449.008 189.738C447.091 194.367 446.589 199.461 447.567 204.375C448.544 209.289 450.957 213.803 454.5 217.346L472.413 199.433L472.413 174.1Z",
    fill: "#2B306E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M460.867 166.126H432.286V167.02H460.867V166.126Z",
    fill: "#333232"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95,
    filter: "url(#filter6_dd_369_1662)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.664,
    y: 161.661,
    width: 54.4824,
    height: 21.4357,
    rx: 3,
    fill: "#2B306E"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M313.497 167.913H298.313V171.485H313.497V167.913Z",
    fill: "#ECEDFF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M321.535 175.058H290.274V176.844H321.535V175.058Z",
    fill: "#ECEDFF"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95,
    filter: "url(#filter7_dd_369_1662)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.664,
    y: 209.891,
    width: 54.4824,
    height: 21.4357,
    rx: 3,
    fill: "#2B306E"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M313.497 216.144H298.313V219.716H313.497V216.144Z",
    fill: "#ECEDFF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M321.535 223.289H290.274V225.075H321.535V223.289Z",
    fill: "#ECEDFF"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95,
    filter: "url(#filter8_dd_369_1662)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.664,
    y: 185.776,
    width: 54.4824,
    height: 21.4357,
    rx: 3,
    fill: "#2B306E"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M313.497 192.028H298.313V195.6H313.497V192.028Z",
    fill: "#ECEDFF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M321.535 199.173H290.274V200.96H321.535V199.173Z",
    fill: "#ECEDFF"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95,
    filter: "url(#filter9_dd_369_1662)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 188.455,
    y: 161.661,
    width: 83.9564,
    height: 69.666,
    rx: 3,
    fill: "#2B306E"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M241.152 172.378H198.28V175.951H241.152V172.378Z",
    fill: "#ECEDFF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M241.152 179.523H198.28V181.31H241.152V179.523Z",
    fill: "#ECEDFF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M215.25 213.463H198.28V214.357H215.25V213.463Z",
    fill: "#ECEDFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_369_1662",
    x: 26.5117,
    y: 373.732,
    width: 504.391,
    height: 16.7646,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_369_1662"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_369_1662",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_369_1662",
    x: 336.506,
    y: 159.661,
    width: 95.9951,
    height: 73.666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_369_1662"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_369_1662",
    result: "effect2_dropShadow_369_1662"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_369_1662",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_369_1662",
    x: 186.455,
    y: 241.831,
    width: 246.045,
    height: 99.5674,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_369_1662"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_369_1662",
    result: "effect2_dropShadow_369_1662"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_369_1662",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_369_1662",
    x: 28.9746,
    y: 265.553,
    width: 165.05,
    height: 89.1318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_369_1662"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_369_1662",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_369_1662",
    x: 398.137,
    y: 255.728,
    width: 122.179,
    height: 89.1318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_369_1662"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_369_1662",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_369_1662",
    x: 411.534,
    y: 147.657,
    width: 108.537,
    height: 100.743,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_369_1662"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_369_1662",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_dd_369_1662",
    x: 276.664,
    y: 159.661,
    width: 58.4824,
    height: 25.4355,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_369_1662"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_369_1662",
    result: "effect2_dropShadow_369_1662"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_369_1662",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_dd_369_1662",
    x: 276.664,
    y: 207.891,
    width: 58.4824,
    height: 25.4355,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_369_1662"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_369_1662",
    result: "effect2_dropShadow_369_1662"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_369_1662",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_dd_369_1662",
    x: 276.664,
    y: 183.776,
    width: 58.4824,
    height: 25.4355,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_369_1662"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_369_1662",
    result: "effect2_dropShadow_369_1662"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_369_1662",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_dd_369_1662",
    x: 186.455,
    y: 159.661,
    width: 87.9561,
    height: 73.666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_369_1662"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_369_1662",
    result: "effect2_dropShadow_369_1662"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_369_1662",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_369_1662",
    x1: 123.863,
    y1: 218.596,
    x2: 123.863,
    y2: 354.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00B1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg5Sect4);
export default __webpack_public_path__ + "static/media/img5Sect4.7f29d9fb7c5b1853d1e6f80f87457fce.svg";
export { ForwardRef as ReactComponent };